import { render, staticRenderFns } from "./groupMain.vue?vue&type=template&id=1c6a5f72"
import script from "./groupMain.vue?vue&type=script&lang=js"
export * from "./groupMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports